import * as React from "react";
import mergeStyles from "./mergeStyles";

function prefillProps<P>(
  Component: React.ComponentType<P>,
  prefilledProps: Partial<P>
): React.ComponentType<P & { ref?: any }> {
  function PrefillProps(props: P, ref: any) {
    return (
      <Component
        ref={ref}
        {...props}
        {...prefilledProps}
        style={mergeStyles((prefilledProps as any).style, (props as any).style)}
      />
    );
  }

  return React.forwardRef(PrefillProps) as any;
}

export default prefillProps;
